import { Button } from "ui2";

import { PinPad } from "safety/components/attendance/PinPad";
import { SubScreenHeader } from "safety/components/attendance/SubScreenHeader";

type PinScreenProps = {
  meetingName: string;
  pin: string;
  pinError: string | null;
  disabled: boolean;
  onChange: (value: string) => void;
  onBack: () => void;
  onForgotPin: () => void;
};

export const PinScreen = ({
  meetingName,
  pin,
  pinError,
  disabled,
  onChange,
  onBack,
  onForgotPin,
}: PinScreenProps): React.JSX.Element => (
  <>
    <SubScreenHeader meetingName={meetingName} onBack={onBack} />
    <div className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:p-5">
      <h1 className="tw:m-0 tw:text-center tw:text-2xl tw:font-denim tw:text-midnight">Your kiosk PIN</h1>
      <div className="tw:mt-6">
        <PinPad pin={pin} pinError={pinError} disabled={disabled} onChange={onChange} />
        <div className="tw:mt-4 tw:hidden tw:text-center tw:text-sm tw:text-midnight/50 tw:sm:block">
          Type the digits. The fourth one submits.
        </div>
      </div>
      <div className="tw:mt-auto tw:flex tw:justify-center tw:pt-6">
        <Button className="tw:h-auto tw:p-0 tw:text-sm" variant="link" onClick={onForgotPin}>
          Forgot your PIN?
        </Button>
      </div>
    </div>
  </>
);
